export const gamesImagesAssetsUrl: string = 'https://static-assets.lvbet.lv/images/';
